<template>
  <div
    class="fixed right-5 top-1/2 -translate-y-1/2 z-50 cursor-pointer transition-all duration-300 ease-in-out hover:scale-110 hover:-translate-y-1/2 drop-shadow-lg hover:drop-shadow-2xl animate-bounce"
    @click="openAgentLink"
    :title="currentLocale === 'zh-CN' ? '成为代理' : 'Become Agent'"
  >
    <div class="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 transition-all duration-300 ease-in-out rounded-lg overflow-hidden">
      <img
        :src="agentImageSrc"
        :alt="currentLocale === 'zh-CN' ? '成为代理' : 'Become Agent'"
        class="w-full h-full object-cover"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import agentImageCn from '@/assets/images/agent_cn.png'
import agentImageEn from '@/assets/images/agent_en.png'

const { locale } = useI18n()

// 计算当前语言
const currentLocale = computed(() => locale.value)

// 根据语言计算图片路径
const agentImageSrc = computed(() => {
  return currentLocale.value === 'zh-CN'
    ? agentImageCn
    : agentImageEn
})

const AGENT_LINK = 'https://zfrmz.com/XhvTXQSxM6jeHbqPDMaA'

const openAgentLink = (event) => {
  // iOS WebView 要求 window.open 必须在用户手势内同步调用，不能放在 setTimeout 里
  const w = window.open(AGENT_LINK, '_blank')
  if (!w) {
    // 若被拦截（如部分浏览器），降级为修改 location
    window.location.href = AGENT_LINK
  }
  // 点击反馈：在打开后再做动画，不影响 iOS 的同步要求
  const element = event.currentTarget
  element.style.transform = 'translateY(-50%) scale(0.95)'
  // setTimeout(() => {
  //   element.style.transform = 'translateY(-50%) scale(1)'
  // }, 150)
}
</script>

<style scoped>
/* 自定义动画，因为Tailwind的animate-bounce可能不够平滑 */
@keyframes custom-float {
  0%, 100% {
    transform: translateY(-60%);
  }
  50% {
    transform: translateY(-70%);
  }
}

.animate-bounce {
  animation: custom-float 3s ease-in-out infinite;
}

/* 移动端适配 */

</style>
